import { render, staticRenderFns } from "./PurchaseItemTable.vue?vue&type=template&id=32d3f7ce&scoped=true"
import script from "./PurchaseItemTable.vue?vue&type=script&lang=js"
export * from "./PurchaseItemTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseItemTable.vue?vue&type=style&index=0&id=32d3f7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3f7ce",
  null
  
)

export default component.exports